<script>
  export let selectedProject = -1;
  export let selProject = null;
  export let refreshProjects = false;

  //import Menu from "../../../components/Menu.svelte";
  import { onMount } from "svelte";

  // Just in case you need to access the database through the simplerest API
  import { getAllProjects, getProject } from "../../../js/projects";
  import { copyObject } from "../../../js/copyObject";
  import {
    getUserId,
    getRole,
    getOutlookEmail,
    getPlatform,
  } from "../../../js/localInfo";
  import TasksBox from "./components/TasksBox.svelte";
  //import ListBox from "./components/ListBox.svelte";
  import Calendar from "./components/Calendar.svelte";
  import SmallInfoBox from "./components/SmallInfoBox.svelte";
  import AppsListBox from "./components/AppsListBox.svelte";
  import LicensesBox from "../../tools/screens/components/LicensesBox.svelte";
  /* import LicensesBox from "./components/LicensesBox.svelte"; */
  //import RoomDataSheet from "./components/RoomDataSheet.svelte";
  import ProjectStaff from "./components/ProjectStaff.svelte";
  import AllPeopleTasks from "./components/AllPeopleTasks.svelte";
  //import Planner from "../../../components/Planner/Planner.svelte";
  import Loading from "../../../components/Loading.svelte";
  import WebBrowser from "../../../components/WebBrowser.svelte";
  import ContextMenu from "../../../components/ContextMenu.svelte";
  import CompleteResourcePlanner from "../../../components/CompleteResourcePlanner/CompleteResourcePlanner.svelte";
  import { post } from "../../../js/labit-connection";
  import {
    outlookGetTasks,
    outlookLogin,
  } from "../../../components/dashboard/outlook/outlook.js";
  import { openURL } from "../../../js/openURL";
  import { openNewWindow } from "../../../js/openNewWindow";
  import {
    setLastProjectPDashboard,
    getLastProjectPDashboard,
  } from "../../../js/localInfo";

  const PAGE = "PDASHBOARD";

  const platform = getPlatform();

  let currentProject = null;
  let currentPlan = null;
  let apps = [];

  let myId = getUserId();
  let myRole = getRole();
  //let myId = 29;
  let myToDoTasks = [];
  let myPendingTasks = [];
  let myLastAssign = [];
  let myBacklogTasks = [];
  let now = moment().format("YYYY-MM-DD HH:mm:ss");
  let myProjectsList = [];
  let projectDropDownMenu = false;
  let siteMonitoring = [];
  let myMail = "";

  let loadingProjects = false;

  let canEdit = false;

  let loaded = false;

  let doneAllTasks = [];
  let inProgressAllTasks = [];
  let toDoAllTasks = [];
  let doneAllMyTasks = [];
  let inProgressAllMyTasks = [];
  let toDoAllMyTasks = [];

  let changedStatus = "";
  
  let allTasksLink = "";

  let showTool = "";
  let showNavMenu = null;
  let toolURL = "";

  let getMyMail = async () => {
    let response = await post(
      `SELECT Email
      FROM people
      WHERE contact_id = ` + myId
    );
    myMail = response[0].Email;
  };

  onMount(async () => {
    // Cargar listado de proyectos asociados
    await getMyMail();
    await prepareProjects();
    loaded = true;
  });

  let prepareProjects = async () => {
    await getMyProjects();
    //console.log("97: " + myProjectsList);
    if (myProjectsList.length > 0) {
      if (selectedProject !== -1) {
        const pos = myProjectsList.findIndex((item) => {
          return item.id === selectedProject;
        });
        if (pos >= 0) {
          loadProjectSelected(myProjectsList[pos]);
          setLastProjectPDashboard(myProjectsList[pos].id);
        } else {
          loadProjectSelected(myProjectsList[0]);
          setLastProjectPDashboard(myProjectsList[0].id);
        }
        selectedProject = -1;
      } else {
        if (selProject) {
          const pos = myProjectsList.findIndex((item) => {
            return item.id === selProject;
          });
          if (pos >= 0) {
            loadProjectSelected(myProjectsList[pos]);
            setLastProjectPDashboard(myProjectsList[pos].id);
          } else {
            loadProjectSelected(myProjectsList[0]);
            setLastProjectPDashboard(myProjectsList[0].id);
          }
        } else {
          const projectId = getLastProjectPDashboard();
          const pos = myProjectsList.findIndex((item) => {
            return item.id === projectId;
          });
          if (pos >= 0) {
            loadProjectSelected(myProjectsList[pos]);
          } else {
            loadProjectSelected(myProjectsList[0]);
          }
        }
      }
    }
    loaded = true;
  };

  let toggleProjectMenu = () => {
    projectDropDownMenu = !projectDropDownMenu;
  };

  let adjustScopesList = () => {
    currentProject.scopes = currentProject.scopes.reduce((acc, curr) => {
      acc.push({
        name: curr,
        date: null,
      });
      return acc;
    }, []);
  };

  let loadProjectSelected = async (project) => {
    canEdit = false;
    if (myRole === "Admin" || myRole === "Analytics") {
      canEdit = true;
    } else {
      /*const today = moment().format("YYYY-MM-DD");
      const pos = project.people.findIndex((p) => {
        return (
          p.peopleId === myId.toString() &&
          p.role === "Project Manager" &&
          p.start <= today &&
          p.end >= today
        );
      });
      canEdit = pos >= 0;*/
      for (let i = 0; i < project.phases.length && !canEdit; i++) {
        const phase = project.phases[i];
        for (let j = 0; j < phase.people.length && !canEdit; j++) {
          const p = phase.people[j];
          if (p.peopleId === myId.toString() && p.role === "Project Manager") {
            canEdit = true;
          }
        }
      }
    }
    loadingProjects = true;
    projectDropDownMenu = false;
    resetVariables();
    currentProject = copyObject(project);
    console.log("-Proyecto Seleccionado: ", currentProject);

    setLastProjectPDashboard(currentProject.id);

    /* await loadSiteMonitoring(); */
    generateAppList();
    adjustScopesList();
    await getTasks();
    currentProject = currentProject;
  };

  let getMyProjects = async () => {
    myProjectsList = [];
    let projects = await getAllProjects(true, myId);
    for (let i = 0; i < projects.length; i++) {
      if (projects[i].active) {
        if (
          myRole !== "Admin" ||
          (myRole === "Admin" && projects[i].lastName.trim() !== "Labit Group")
        ) {
          myProjectsList.push(projects[i]);
        }
      }
    }
    refreshProjects = false;
  };

  let getTasks = async () => {
    const projectName = currentProject.folderLabitCode;
    toDoAllMyTasks = toDoAllMyTasks;
    inProgressAllMyTasks = inProgressAllMyTasks;
    doneAllMyTasks = doneAllMyTasks;

    toDoAllTasks = toDoAllTasks;
    inProgressAllTasks = inProgressAllTasks;
    doneAllTasks = doneAllTasks;
    outlookGetTasks(
      projectName,
      (plan, link) => {
        allTasksLink = link;
        prepareAllPeopleTasks(plan);
        currentPlan = plan;
        /*prepareTaskList();*/
        loadingProjects = false;
      },
      () => {
        outlookLogin(
          () => {
            outlookGetTasks(
              projectName,
              (plan, link) => {
                allTasksLink = link;
                prepareAllPeopleTasks(plan);
                currentPlan = plan;
                /*prepareTaskList();*/
                loadingProjects = false;
              },
              () => {
                loadingProjects = false;
              }
            );
          },
          () => {
            loadingProjects = false;
          }
        );
      }
    );
  };

  let generateAppList = () => {
    apps = [];
    currentProject.externalUrls.forEach((url) => {
      if (url.type === "Server") {
        apps.push({
          img: "/images/folder.png",
          link: url.url,
        });
      }
    });
    currentProject.externalUrls.forEach((url) => {
      if (url.type === "Trello") {
        apps.push({
          img: "/images/trello.png",
          link: url.url,
        });
      }
    });
    currentProject.externalUrls.forEach((url) => {
      if (url.type === "Slack") {
        apps.push({
          img: "/images/slack.png",
          link: url.url,
        });
      }
    });
    currentProject.externalUrls.forEach((url) => {
      if (url.type === "Sharepoint") {
        apps.push({
          img: "/images/sharepoint.png",
          link: url.url,
        });
      }
    });
    currentProject.externalUrls.forEach((url) => {
      if (url.type === "BIM360") {
        apps.push({
          img: "/images/bim360.png",
          link: url.url,
        });
      }
    });
    apps = apps;
  };

  let resetVariables = () => {
    myToDoTasks = [];
    myPendingTasks = [];
    myLastAssign = [];
    myBacklogTasks = [];
    siteMonitoring = [];
    apps = [];
    currentPlan = null;
    currentProject = null;
  };

  let orderListH = (list) => {
    list.sort(function (a, b) {
      if (
        moment(a.created, "YYYY-MM-DD HH:mm:ss").format("YYYYMMDDHHmmss") >
        moment(b.created, "YYYY-MM-DD HH:mm:ss").format("YYYYMMDDHHmmss")
      ) {
        return -1;
      }
      if (
        moment(a.created, "YYYY-MM-DD HH:mm:ss").format("YYYYMMDDHHmmss") <
        moment(b.created, "YYYY-MM-DD HH:mm:ss").format("YYYYMMDDHHmmss")
      ) {
        return 1;
      }
      return 0;
    });
    return list;
  };

  let prepareTaskList = () => {
    for (let i = 0; i < currentPlan.phases.length; i++) {
      let phase = currentPlan.phases[i];
      for (let j = 0; j < phase.people.length; j++) {
        let p = phase.people[j];
        if (phase.people[j].email === myMail) {
          /*           let projectPhase = currentProject.phases.find((item) => {
            return item.name === phase.name;
          }); */
          /*           phase.start = projectPhase.start;
          phase.end = projectPhase.end;
          myPhases.push(phase); */
          phase.people[j].tasks.toDo.forEach((t) => {
            myToDoTasks.push({
              from: t.name,
              datetime: moment(t.created, "YYYY-MM-DD").format(
                "YYYY-MM-DD HH:mm:ss"
              ),
              subject: phase.name,
              created: t.created,
            });
            if (
              moment(now, "YYYY-MM-DD HH:mm:ss").diff(
                moment(t.created, "YYYY-MM-DD HH:mm:ss"),
                "hours"
              ) < 24
            ) {
              myLastAssign.push({
                from: t.name,
                datetime: null,
                subject: phase.name,
                created: t.created,
              });
            }
          });
          phase.people[j].tasks.pending.forEach((t) => {
            myPendingTasks.push({
              from: t.name,
              datetime: moment(t.created, "YYYY-MM-DD").format(
                "YYYY-MM-DD HH:mm:ss"
              ),
              subject: phase.name,
              created: t.created,
            });
            if (
              moment(now, "YYYY-MM-DD HH:mm:ss").diff(
                moment(t.created, "YYYY-MM-DD HH:mm:ss"),
                "hours"
              ) < 24
            ) {
              myLastAssign.push({
                from: t.name,
                datetime: null,
                subject: phase.name,
                created: t.created,
              });
            }
          });
          phase.people[j].tasks.backlog.forEach((t) => {
            myBacklogTasks.push({
              from: t.name,
              datetime: null,
              subject: phase.name,
              created: t.created,
            });
            if (
              moment(now, "YYYY-MM-DD HH:mm:ss").diff(
                moment(t.created, "YYYY-MM-DD HH:mm:ss"),
                "hours"
              ) < 24
            ) {
              myLastAssign.push({
                from: t.name,
                datetime: null,
                subject: phase.name,
                created: t.created,
              });
            }
          });
        }
      }
    }

    myToDoTasks = orderListH(myToDoTasks);
    myPendingTasks = orderListH(myPendingTasks);
    myLastAssign = orderListH(myLastAssign);
    myBacklogTasks = orderListH(myBacklogTasks);
  };

  let selectProject = () => {
    if (loaded) {
      const pos = myProjectsList.findIndex((item) => {
        return item.id === selectedProject;
      });
      if (pos >= 0) {
        loadProjectSelected(myProjectsList[pos]);
      }
      selectedProject = -1;
    }
  };

  let prepareAllPeopleTasks = (plan) => {
    toDoAllMyTasks = [];
    inProgressAllMyTasks = [];
    doneAllMyTasks = [];

    toDoAllTasks = [];
    inProgressAllTasks = [];
    doneAllTasks = [];

    plan.forEach((e) => {
      if (e.email === getOutlookEmail()) {
        // All my tasks
        toDoAllMyTasks = toDoAllMyTasks.concat(e.tasks.toDo);
        inProgressAllMyTasks = inProgressAllMyTasks.concat(e.tasks.inProgress);
        doneAllMyTasks = doneAllMyTasks.concat(e.tasks.done);
      }
      toDoAllTasks = toDoAllTasks.concat(e.tasks.toDo);
      inProgressAllTasks = inProgressAllTasks.concat(e.tasks.inProgress);
      doneAllTasks = doneAllTasks.concat(e.tasks.done);

      let t = [];
      t = toDoAllTasks.reduce((acc, curr) => {
        const pos = acc.findIndex((i) => {
          return i.id === curr.id;
        });
        if (pos === -1) {
          acc.push(curr);
        }
        return acc;
      }, []);
      toDoAllTasks = t;

      t = [];
      t = inProgressAllTasks.reduce((acc, curr) => {
        const pos = acc.findIndex((i) => {
          return i.id === curr.id;
        });
        if (pos === -1) {
          acc.push(curr);
        }
        return acc;
      }, []);
      inProgressAllTasks = t;

      t = [];
      t = doneAllTasks.reduce((acc, curr) => {
        const pos = acc.findIndex((i) => {
          return i.id === curr.id;
        });
        if (pos === -1) {
          acc.push(curr);
        }
        return acc;
      }, []);
      doneAllTasks = t;
    });

    plan = plan;
    currentPlan = currentPlan;

    toDoAllMyTasks = toDoAllMyTasks;
    inProgressAllMyTasks = inProgressAllMyTasks;
    doneAllMyTasks = doneAllMyTasks;

    toDoAllTasks = toDoAllTasks;
    inProgressAllTasks = inProgressAllTasks;
    doneAllTasks = doneAllTasks;
  };

  let closeTool = () => {
    showTool = "";
  };

  let clickTool = (url, forceNewWindow) => {
    toolURL = url;
    console.log(toolURL);
    if (platform === "Web") {
      openNewWindow(toolURL);
    } else {
      if (forceNewWindow) {
        openNewWindow(toolURL);
      } else {
        showTool = toolURL;
      }
    }
  };

  $: if (selectedProject !== -1) {
    selectProject();
  }

  $: if (refreshProjects === true) {
    prepareProjects();
  }
</script>

<!-- Menu -->
<div class="content">
  {#if currentProject}
    <div
      class="projectSelectorContainer"
      on:click={() => {
        if (!loadingProjects) {
          toggleProjectMenu();
        }
      }}
    >
      <div
        class="projectImgContainer"
        style="background-image: url({currentProject.pic});"
      />
      <div class="projectNameContainer">
        <span>{currentProject.folderLabitCode} - {currentProject.name}</span>
        {#if loadingProjects}<div class="loader">
            <Loading size="50px" />
          </div>{/if}
      </div>
      <div class="downArrow">
        <img src="images/down_arrow.svg" alt="" />
      </div>
    </div>
    <div
      class="projectListContainer {projectDropDownMenu ? '' : 'hiddenElement'}"
    >
      {#each myProjectsList as project}
        <div
          class={project.active ? "selectableProject" : "noActiveProject"}
          on:click={async () => {
            await loadProjectSelected(project);
          }}
        >
          <div
            class="projectImgContainer"
            style="background-image: url({project.pic}); "
          />
          <div class="projectNameContainer">
            <span>{project.folderLabitCode} - {project.name}</span>
          </div>
        </div>
      {/each}
    </div>
  {/if}
  <div class="boxContainer">
    {#if currentProject}
      <div class="firstCol">
        <div class="largeBox">
          <div
            class="projectImg"
            style="background-image: url({currentProject.pic});"
          />
          <div class="projectInfo">
            <div class="skylabTitle">
              <span>{currentProject.name}</span>
            </div>
            <div class="projectData">
              <span>City: {currentProject.city}</span>
              <br />
              <span>Address: {currentProject.address}</span>
              <br />
              <!-- svelte-ignore missing-declaration -->
              <span
                >Year: {moment(currentProject.start, "YYYY-MM-DD").format(
                  "YYYY"
                )}</span
              >
              <br />
            </div>
          </div>
        </div>
        <div class="projectInfo">
          <div
            class="dashboardItemLarge {canEdit ? 'dashboardItemLargeHalf' : ''}"
          >
            <SmallInfoBox text={currentProject.currentStatus.toUpperCase()} />
          </div>
          {#if canEdit}
            <div class="dashboardItemLarge dashboardItemLargeHalf">
              <div
                class="editProject fadedButton"
                on:click={() =>
                  openURL("/project-analytics/pm/" + currentProject.id, true)}
                on:contextmenu={(ev) => {
                  ev.stopPropagation();
                  openNewWindow(
                    "/skylab-main/project-analytics/pm/" + currentProject.id
                  );
                  return false;
                }}
              >
                <img src="/images/edit.svg" alt="Edit Project" />
                <span>EDIT</span>
              </div>
            </div>
          {/if}
        </div>
      </div>
      <div class="infoCardBox">
        <div class="dashboardItem">
          <Calendar
            dashboard={true}
            project={currentProject}
            plan={currentPlan}
          />
        </div>
        <!-- <div class="dashboardItem">
          <TasksBox boxTitle={"Backlog"} taskList={myBacklogTasks} />
        </div> -->
        <div class="dashboardItem">
          <TasksBox
            boxTitle={"To do"}
            taskList={toDoAllMyTasks}
            onChange={() => getTasks()}
          />
        </div>
        <div class="dashboardItem">
          <TasksBox
            boxTitle={"In progress"}
            taskList={inProgressAllMyTasks}
            onChange={() => getTasks()}
          />
        </div>
        <!--<div class="dashboardItem">
          <TasksBox boxTitle={"Last Assign"} taskList={myLastAssign} />
        </div> -->
        <div class="dashboardItem">
          <AppsListBox
            boxTitle="Apps"
            {apps}
            onClick={(url, forceNewWindow) => clickTool(url, forceNewWindow)}
          />
        </div>

        <div class="dashboardItem">
          <LicensesBox projectId={currentProject.id} />
        </div>
        <!-- <div class="dashboardItem">
          <ListBox boxTitle={"Scope"} list={currentProject.scopes} />
        </div> -->
        <!-- <div class="dashboardItem">
          <ListBox boxTitle={"Site Monitoring"} list={siteMonitoring} />
        </div> -->
        <!--         <div class="dashboardItem">
          <RoomDataSheet
            boxTitle={"Room data sheet"}
            projectId={currentProject.id}
          />
        </div> -->
        <div class="dashboardItem">
          <ProjectStaff boxTitle={"Project Staff"} project={currentProject} />
        </div>
        <div class="dashboardItem doubleWidget" on:click={ () => clickTool(allTasksLink, false) }>
          <AllPeopleTasks
            id="peopleTasksChart"
            boxTitle={"Project Progress"}
            nTodo={toDoAllTasks.length}
            nInProgress={inProgressAllTasks.length}
            nDone={doneAllTasks.length}
          />
        </div>
        <div class="dashboardItem doubleWidget" on:click={ () => clickTool(allTasksLink, false) }>
          <AllPeopleTasks
            id="myTasksChart"
            boxTitle={"My Progress"}
            nTodo={toDoAllMyTasks.length}
            nInProgress={inProgressAllMyTasks.length}
            nDone={doneAllMyTasks.length}
          />
        </div>
      </div>
    {/if}
  </div>
  <div class="tool {showTool !== '' ? '' : 'hiddenElement'}">
    <div class="toolOptions">
      <img
        class="fadedButton"
        src="/images/x.svg"
        alt="Close Tool"
        on:click={() => closeTool()}
      />
    </div>
    <div class="toolWebview">
      <WebBrowser
        id="pdToolWebview"
        type="webview"
        iframeTitle="External Tool"
        src={showTool}
        bind:showMenu={showNavMenu}
      />
    </div>
  </div>
  <!--<div class="planner">
    <Planner project={currentProject} plan={currentPlan} />
  </div>-->
  {#if currentProject}
    <div class="planner">
      <CompleteResourcePlanner projectId={currentProject.id} editable={false} />
    </div>
  {/if}
</div>
{#if platform === "APP" && showTool !== ""}
  <ContextMenu currentURL={toolURL} bind:showMenu={showNavMenu} />
{/if}

<!-- Menu -->
<style>
  div.boxContainer {
    width: 1640px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 20px;
  }

  div.largeBox {
    width: 260px;
    height: 450px;
    background-color: var(--labit-white);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    /*margin-bottom: 20px;*/
  }

  div.projectImg {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    width: 100%;
    height: 300px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  div.skylabTitle {
    padding: 8px;
    color: var(--labit-card-gray);
  }

  div.projectData {
    padding-left: 8px;
    padding-right: 8px;
    color: var(--labit-card-gray);
    /*     margin-bottom: 12px; */
  }

  div.skylabTitle span {
    font-size: 25px;
    font-weight: bold;
  }

  div.dashboardItem {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 260px;
    height: 300px;
    background-color: white;
    border-radius: 14px;
    margin-bottom: 20px;
  }

  div.dashboardItemLarge {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 260px;
    border-radius: 14px;
    height: 100%;
    padding-top: 20px;
  }

  div.dashboardItemLargeHalf {
    height: 50% !important;
  }

  div.infoCardBox {
    width: 83%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  div.planner {
    width: 100%;
    margin-bottom: 20px;
    height: 800px;
    display: flex;
    margin-top: 20px;
  }

  div.projectSelectorContainer {
    width: 100%;
    height: 60px;
    border-radius: 14px;
    margin-top: 20px;
    background-color: var(--labit-white);
    display: flex;
    align-items: center;
    padding: 0 40px 0 40px;
    cursor: pointer;
    color: var(--labit-card-gray);
  }

  div.downArrow {
    width: 20px;
    height: 20px;
  }

  div.projectImgContainer {
    width: 40px;
    height: 40px;
    border-radius: 5px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  div.projectNameContainer {
    margin-left: 20px;
    width: 95%;
    display: flex;
    align-items: center;
  }

  div.projectNameContainer span {
    font-size: 22px;
    font-weight: bold;
  }

  div.projectListContainer {
    margin-top: 20px;
    background-color: var(--labit-white);
    display: flex;
    flex-direction: column;
    border-radius: 14px;
  }

  div.selectableProject,
  div.noActiveProject {
    padding-left: 40px;
    display: flex;
    height: 60px;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    opacity: 1;
    transition: opacity 0.5s linear 0s;
  }

  div.selectableProject:hover {
    opacity: 0.5;
  }

  div.noActiveProject {
    filter: grayscale();
    opacity: 0.5;
  }

  div.loader {
    display: flex;
    justify-content: center;
    margin-left: 20px;
  }

  div.projectInfo {
    height: 170px;
  }

  div.editProject {
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--labit-card-gray);
    font-size: 18px;
    font-weight: bold;
    border-radius: 14px;
  }

  div.editProject img {
    width: 18px;
    margin-right: 6px;
  }

  div.doubleWidget {
    width: 535px !important;
  }

  div.tool {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  div.toolOptions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  div.toolOptions img {
    width: 10px;
  }

  div.toolWebview {
    width: 100%;
    height: 800px;
  }
</style>
